import type { Action } from 'modules/global/generic.types';
import { createReducer } from 'utils/ReduxUtils';

import type { WrapperReducerConfig } from './reducers.types';
import { isSuccessRequest, isFailureRequest } from './utils';

export const onSuccessRequest = (_: boolean, { payload }: Action<{ lastSk?: string, content: unknown[] }>): boolean =>
  Boolean(payload?.lastSk) && Boolean(payload?.content?.length && payload?.content?.length > 0);

const hasMore = (actionRoot: string, { reducers = {}, matchers = [], global: config }: WrapperReducerConfig<boolean> = {}) =>
  createReducer(false, reducers, [
    {
      matcher: isSuccessRequest(actionRoot, config ?? {}),
      reducer: onSuccessRequest
    },
    {
      matcher: isFailureRequest(actionRoot, config ?? {}),
      reducer: () => false
    },
    ...matchers
  ]);

export default hasMore;
